// principal + monthly contribution, compounded monthly at `monthlyRate`.
export const calculateCompoundInterest = ({
  principal,
  monthlyContribution,
  monthlyRate,
  months,
}) => {
  let balance = principal
  let totalInvested = principal

  for (let i = 0; i < months; i++) {
    balance = balance * (1 + monthlyRate) + monthlyContribution
    totalInvested += monthlyContribution
  }

  return {
    finalBalance: balance,
    totalInvested,
    totalInterest: balance - totalInvested,
  }
}
